import type EnType from '../en-US/commonParameter';

export default {
  'commonParameter.title.addParameter': 'Adicionar Parâmetros',
  'commonParameter.title.name': 'Nome',
  'commonParameter.title.nameNotNull.message': 'O nome não pode estar vazio!',
  'commonParameter.placeHolder.chooseType': 'Escolher Tipo',
} satisfies typeof EnType;
